<template>
  <div style="height: 100%; width: 100%;">
    <div class="video-wrapper">
    <transition name="slide-x-transition">
      <video ref="video"
             v-show="mediaReady"
             :class="{'blur-on': showOverlay || paused}"
             style="height:100%; width:100%;"
             @click="togglePlayPauseInternally()"
      >
      </video>
    </transition>
      <v-chip small class="center elevation-5" v-if="!showOverlay && paused" @click="togglePlayPauseInternally()">Video Paused</v-chip>
      <v-btn
          @click="togglePlayPauseInternally()"
          color="white"
          icon
          class="center"
          v-if="showOverlay && mediaReady"
      >
        <v-icon size="100">
          mdi-play-circle-outline
        </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>

  export default {
    name: "MediaCompositionVideo",
    props: {
      id: {
        required: true,
      },
      video: {
        type: String,
        required: true,
      },
      volume: {
        type: Number,
        required: true,
      },
      autoplay: {
        default: false,
        type: Boolean
      },
      onProgress: {
        type: Function
      }
    },
    data() {
      return {
        showOverlay: false,
        steps: {
          'initVideo': false,
        },
        paused: false,
        mediaReady: false,
      }
    },
    watch: {
      'volume': function () {
        this.$refs.video.volume = this.volume;
      }
    },
    methods: {
      togglePlayPauseInternally(){
        if(this.showOverlay){
          this.showOverlay = false;
          this.$emit('showControls');
          this.$emit('play');
        }
        else {
          this.paused ? this.$emit('play') : this.$emit('pause');
        }
      },
      play() {
        this.showOverlay = false;
        this.$refs.video.play().catch(()=>{
          this.$emit('pause');
        });
        this.paused = false;
        this.startUpdatingCurrentTime();
      },
      pause() {
        this.$refs.video.pause();
        this.paused = true;
      },
      forward(time = 5) {
        this.$refs.video.currentTime = Math.min(parseFloat(time + this.$refs.video.currentTime), this.$refs.video.duration);

        if (this.onProgress) {
          this.onProgress(this.$refs.video.currentTime);
        }
      },
      backward(time = 5) {
        this.$refs.video.currentTime = Math.max(parseFloat(this.$refs.video.currentTime - time), 0);

        if (this.onProgress) {
          this.onProgress(this.$refs.video.currentTime);
        }
      },
      reset() {
        this.paused = false;
        this.$refs.video.pause();
        this.$refs.video.currentTime = 0;

        this.showOverlay = true;
      },
      initVideo() {
        this.$refs.video.src = this.video;
        this.$refs.video.volume = this.volume;

        //Autoplay and looping is managed in media composition
        this.$refs.video.autoplay = false;
        this.$refs.video.loop = false;

      },
      startUpdatingCurrentTime() {
        if (this.mediaReady) {
          this._currentTimeInterval = setInterval(() => {
            if (this.paused) {
              this.stopUpdatingCurrentTime();
            }
            if (this.onProgress) {
              this.onProgress(this.$refs.video.currentTime);
            }
          }, 50);
        }
      },
      stopUpdatingCurrentTime() {
        clearInterval(this._currentTimeInterval);
        this._currentTimeInterval = null;
      }
    },
    beforeDestroy() {
      this.stopUpdatingCurrentTime();
      this.$refs.video.src = '';
      this.$refs.video.remove();
    },
    mounted() {
      this.initVideo();
      this.$refs.video.addEventListener('canplay', () => {
        if (this.mediaReady) return;

        this.steps.initVideo = true;
        this.mediaReady = true;

        //SET MEDIA DURATION
        this.$emit('mediaReady', this.$refs.video.duration);

        if (!this.autoplay) {
          this.showOverlay = true;
        }
        else
        {
          this.$emit('showControls');
        }
      });

      this.$refs.video.addEventListener('ended', () => {
        this.$emit('complete', this.id);
        this.stopUpdatingCurrentTime();
      });

      if (navigator != null && ('mediaSession' in navigator)) {
        navigator.mediaSession.setActionHandler('play', () => {
          this.$emit('play');
        });

        navigator.mediaSession.setActionHandler('pause', () => {
          this.$emit('pause');
        });

        navigator.mediaSession.setActionHandler('previoustrack', () => {
          this.backward();
        });

        navigator.mediaSession.setActionHandler('nexttrack', () => {
          this.forward();
        });
      }
    }
  }
</script>

<style scoped>

  .blur-on, .blur-element {
    -webkit-filter: blur(3px);
    -moz-filter: blur(3px);
    -o-filter: blur(3px);
    -ms-filter: blur(3px);
    filter: blur(3px);
  }

  .video-wrapper {
    position: relative;
    height:100%
  }

  .video-wrapper > video {
    height: 100%;
    width: 100%;
    vertical-align: middle;
  }

  .center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }

</style>
